<script setup>
import { useRoute } from '@js/utils/route';

const { tenant, seoTrackedKeyword, callback } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    seoTrackedKeyword: {
        type: Object,
        required: true,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

function toggleAction() {
    axios
        .post(
            route(
                'front.projectManagement.seo.postToggleTrackedKeywordImportantToFollow',
                {
                    tenant: tenant.id,
                    seoTrackedKeyword: seoTrackedKeyword.id,
                },
            ),
        )
        .then(() => {
            if (callback) {
                callback();
            }
        })
        .catch((error) => {
            console.error(error);
        });
}
</script>

<template>
    <slot name="button" :action="toggleAction" />
</template>
